import React from 'react';
import { Button, Modal, Spin, Tooltip } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { resetPaymentStatus } from './eleve.reducer';
import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import Title from 'antd/lib/typography/Title';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

const ResetStatusHandler = ({ ecoleId, anneeScolaireId }: { ecoleId: string; anneeScolaireId: string }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(state => state.eleve.loading);
  const inactiveAnnee = useCheckIsAnneeInactive(anneeScolaireId);

  const openModal = () => {
    Modal.info({
      title: renderModalTitle(),
      content: renderModalContent(),
      okText: 'Confirmer',
      cancelText: 'Annuler',
      onOk() {
        handleResetPaymentStatus();
      },
      onCancel() {
        Modal.destroyAll();
      },
      okCancel: true,
      closable: true,
      closeIcon: <CloseOutlined style={{ color: '#F28E19' }} />,
      width: '50%',
      okButtonProps: {
        disabled: loading,
        style: { background: '#F28E19', color: 'white', border: '1px solid #F28E19' },
      },
      centered: true,
    });
  };

  const renderModalTitle = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>Confirmation de mise à jour</span>
    </div>
  );

  const renderModalContent = () => (
    <div className="">
      <Title level={5}>
        Êtes-vous sûr de vouloir mettre à jour l&apos;état de paiement des élèves en fonction du statut actuel des factures ?
      </Title>
      <span style={{ color: 'red', fontSize: '16px' }}>
        ⚠ Cette action mettra à jour le statut des élèves qui n&apos;ont pas payé la dernière mensualité.
      </span>
    </div>
  );

  const handleResetPaymentStatus = () => {
    const entity = {
      ecoleId,
      anneeScolaireId,
    };
    dispatch(resetPaymentStatus(entity));
  };
  const shouldDisable = anneeScolaireId === 'null' || inactiveAnnee;
  return (
    <div>
      <Tooltip title="Met à jour l’état des élèves n’ayant pas payé leur scolarité. Cela entraînera une restriction d’accès à l’établissement.">
        <Button
          type="primary"
          onClick={openModal}
          disabled={loading || shouldDisable}
          style={{
            backgroundColor: loading ? '#ccc' : 'red',
            border: `1px solid ${loading ? '#ccc' : 'red'}`,
            fontWeight: '700',
          }}
        >
          {!loading && <FontAwesomeIcon icon={faRedoAlt} />}
          &nbsp; {loading ? <Spin /> : `Mise à jour statut paiement`}
        </Button>
      </Tooltip>
    </div>
  );
};

export default ResetStatusHandler;
